// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,400;0,700;0,900;1,100;1,400;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root { /* Variables */
  --modal-bg-color: rgba(32, 32, 32, 0.5);
  --modal-bg-hover-color: rgba(32, 32, 32, 0.7);
  --text-color: rgba(240, 240, 240, 1);
  --positive-color: rgba(100, 242, 171, 1);
  --neutral-color: rgba(150, 150, 253, 1);
  --warn-color: rgba(253, 253, 150, 1);
  --negative-color: rgba(255, 81, 72, 1);
  --disabled-color: rgba(125, 125, 125, 1);
  --animation-init-time: 1s; /* Don't forget to change back */
}

html, body {
  margin: 0;
  height: 100%;
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
}

.App {
  background-color: #202020;
  /* background-color: #ffffff; */
}

.App-logo {
  position: fixed;
  top: 15px;
  left: 15px;
  height: 50px;
}

.App-body {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: var(--text-color);
}

.App-hidden {
  display: none !important;
}

.App-chart-container {
  width: 100vw;
  height: 12vh;
}

.App-button {
  padding-right: 100px;
  padding-left: 100px;
  height: 7vh;
  line-height: 7vh;
  font-weight: 900;

  flex-grow: 1;
  margin: 30px;
  border-radius: 40px;
  text-align: center;
  border: 2px solid;

  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;

  display: flex;
  flex-direction: row;

  transition: background-color 0.2s ease-in-out, transform 0.2s ease-in-out;
}

.App-button:active {
  transform: scale(0.9);
}

.App-button-record {
  border-color: var(--negative-color);
  color: var(--negative-color);
}

.App-button-record-hover-allowed:hover {
  background-color: var(--negative-color);
  color: var(--modal-bg-color);
}

.App-button-connect {
  border-color: var(--disabled-color);
  color: var(--disabled-color);
}

.App-button-connect:hover {
  background-color: var(--disabled-color);
  color: var(--modal-bg-color);
}

.App-button-default {
  border-color: var(--disabled-color);
  color: var(--disabled-color);
}

.App-button-default:hover {
  background-color: var(--disabled-color);
  color: var(--modal-bg-color);
}

.App-button-default-active {
  background-color: var(--disabled-color);
  color: var(--modal-bg-color);
}

.App-button-mini {
  padding-right: 25px;
  padding-left: 25px;
  margin-right: 0px;
}

.App-button-fill-space {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-right: 0;
  margin-bottom: -15px;
}

.App-button-container-horizontal {
  display: flex;
  flex-direction: row;
}

.App-button-container-vertical {
  display: flex;
  flex-direction: column;
}

.App-data-type-text {
  padding: 20px;
  font-size: 14px;

  -webkit-user-select: none;
  user-select: none;

  animation-name: fadeIn;
  animation-duration: 0.5s;
  animation-delay: var(--animation-init-time);
  animation-fill-mode: forwards; 
  opacity: 0%; /* Animates to 100% */
}

.App-position-lower-right {
  right: 0px;
  bottom: 0px;
  position: fixed;
}

.App-position-lower-left {
  left: 0px;
  bottom: 0px;
  position: fixed;
}

.App-position-lower-center {
  bottom: 0px;
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.App-position-top-right {
  right: 0px;
  top: 0px;
  position: fixed;
}

.App-recording-circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: var(--negative-color);

  position: relative;
  top: 50%;
  transform: translateY(-50%);

  animation-name: recordingPulse;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

.App-connecting-circle {
  width: 48px;
  height: 48px;
  display: inline-block;

  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.App-connecting-circle::after,
.App-connecting-circle::before {
  content: '';  
  box-sizing: border-box;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid var(--positive-color);
  position: absolute;
  left: 0;
  top: 0;
  animation: connectingPulse 2s linear infinite;
}
.App-connecting-circle::after {
  animation-delay: 1s;
}

.App-fade-in-animation {
  animation-name: fadeIn;
  animation-duration: 0.5s;
  animation-delay: var(--animation-init-time);
  animation-fill-mode: forwards; 
  opacity: 0%; /* Animates to 100% */
}





.Modal-background {
  background-color: var(--modal-bg-color);
  width: 50vw;
  height: 35vh;
  padding: 30px;
  position: absolute;
  border-radius: 50px;
  -webkit-backdrop-filter: blur(7.5px);
          backdrop-filter: blur(7.5px);
  overflow: hidden; 
  box-shadow: 0px 0px 32px 6px rgba(0,0,0,0.5);
  
  transition: background-color 0.2s ease-in-out;
  animation-name: dropIn;
  animation-duration: 0.5s;
  animation-delay: var(--animation-init-time);
  animation-fill-mode: forwards; 

  opacity: 0%; /* Animates to 100% */
}

.Modal-background:hover {
  background-color: var(--modal-bg-hover-color);
}

.Modal-hidden {
  opacity: 100%; /* Animates to 0% */

  transition: background-color 0.2s ease-in-out;
  animation-name: dropOut;
  animation-duration: 0.5s;
  animation-delay: 0s;
  animation-fill-mode: forwards; 
}

.Modal-title {
  font-weight: 900;
  font-size: 5vh;
  text-align: center;
  white-space: nowrap;
}

.Modal-body {
  font-weight: 400;
  font-size: 3vh;
  text-align: center;
  margin-left: 50px;
  margin-right: 50px;

  position: absolute;
  top: 45%;
  transform: translateY(-50%);
}

.Modal-button-container {
  display: flex;
  flex-direction: row-reverse;
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
}

.Modal-button {
  width: 100px;
  height: 7vh;
  line-height: 7vh;
  font-weight: 900;

  flex-grow: 1;
  margin: 30px;
  border-radius: 40px;
  text-align: center;
  border: 2px solid;

  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;

  display: flex;
  flex-direction: row;
  justify-content: center;

  transition: background-color 0.2s ease-in-out, transform 0.2s ease-in-out;
}

.Modal-button:active {
  transform: scale(0.9);
}

.Modal-button-primary {
  border-color: var(--positive-color);
  color: var(--positive-color);
  margin-left: 15px;
}

/* .Modal-button-primary:hover {
  background-color: var(--positive-color);
  color: var(--modal-bg-color);
} */

.Modal-button-primary-hover-allowed:hover {
  background-color: var(--positive-color);
  color: var(--modal-bg-color);
}

.Modal-button-secondary {
  border-color: var(--disabled-color);
  color: var(--disabled-color);
  margin-right: 15px;
}

.Modal-button-secondary:hover {
  background-color: var(--disabled-color);
  color: var(--modal-bg-color);
}

.Modal-button-generic {
  border-color: var(--text-color);
  color: var(--text-color);
  /* margin-right: 15px; */
}

.Modal-button-generic:hover {
  background-color: var(--text-color);
  color: var(--modal-bg-color);
}





@keyframes dropIn {
  0%   {
    margin-top: -100px;
    opacity: 0%;
  }
  100% {
    margin-top: 0px;
    opacity: 100%;
  }
}

@keyframes dropOut {
  0%   {
    margin-top: 0px;
    opacity: 100%;
  }
  100% {
    margin-top: 100px;
    opacity: 0%;
  }
}

@keyframes fadeIn {
  0%   {
    opacity: 0%;
  }
  100% {
    opacity: 100%;
  }
}

@keyframes fillCircle {
  to { stroke-dasharray: 0 100; }
}

@keyframes recordingPulse {
  0%   {
    opacity: 100%;
  }
  50% {
    opacity: 50%;
  }
  100% {
    opacity: 100%;
  }
}

@keyframes connectingPulse {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

/* Plans - generate random waves on site startup and start with full wave, clear and let wave fill in if and when there's a connection */`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA,QAAQ,cAAc;EACpB,uCAAuC;EACvC,6CAA6C;EAC7C,oCAAoC;EACpC,wCAAwC;EACxC,uCAAuC;EACvC,oCAAoC;EACpC,sCAAsC;EACtC,wCAAwC;EACxC,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;;EAEhB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;;EAEjB,eAAe;EACf,yBAAyB;EAEzB,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;;EAEnB,yEAAyE;AAC3E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;;EAEf,yBAAyB;EAEzB,iBAAiB;;EAEjB,sBAAsB;EACtB,wBAAwB;EACxB,2CAA2C;EAC3C,6BAA6B;EAC7B,WAAW,EAAE,qBAAqB;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;;EAEvC,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;;EAE3B,8BAA8B;EAC9B,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;;EAErB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;AACA;;EAEE,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,6CAA6C;AAC/C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,2CAA2C;EAC3C,6BAA6B;EAC7B,WAAW,EAAE,qBAAqB;AACpC;;;;;;AAMA;EACE,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oCAA4B;UAA5B,4BAA4B;EAC5B,gBAAgB;EAGhB,4CAA4C;;EAE5C,6CAA6C;EAC7C,sBAAsB;EACtB,wBAAwB;EACxB,2CAA2C;EAC3C,6BAA6B;;EAE7B,WAAW,EAAE,qBAAqB;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa,EAAE,mBAAmB;;EAElC,6CAA6C;EAC7C,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;;EAElB,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;;EAEhB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;;EAEjB,eAAe;EACf,yBAAyB;EAEzB,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,yEAAyE;AAC3E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;;;;;AAMA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,KAAK,uBAAuB,EAAE;AAChC;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,wIAAwI","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,400;0,700;0,900;1,100;1,400;1,700;1,900&display=swap');\n\n:root { /* Variables */\n  --modal-bg-color: rgba(32, 32, 32, 0.5);\n  --modal-bg-hover-color: rgba(32, 32, 32, 0.7);\n  --text-color: rgba(240, 240, 240, 1);\n  --positive-color: rgba(100, 242, 171, 1);\n  --neutral-color: rgba(150, 150, 253, 1);\n  --warn-color: rgba(253, 253, 150, 1);\n  --negative-color: rgba(255, 81, 72, 1);\n  --disabled-color: rgba(125, 125, 125, 1);\n  --animation-init-time: 1s; /* Don't forget to change back */\n}\n\nhtml, body {\n  margin: 0;\n  height: 100%;\n  overflow: hidden;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.App {\n  background-color: #202020;\n  /* background-color: #ffffff; */\n}\n\n.App-logo {\n  position: fixed;\n  top: 15px;\n  left: 15px;\n  height: 50px;\n}\n\n.App-body {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: var(--text-color);\n}\n\n.App-hidden {\n  display: none !important;\n}\n\n.App-chart-container {\n  width: 100vw;\n  height: 12vh;\n}\n\n.App-button {\n  padding-right: 100px;\n  padding-left: 100px;\n  height: 7vh;\n  line-height: 7vh;\n  font-weight: 900;\n\n  flex-grow: 1;\n  margin: 30px;\n  border-radius: 40px;\n  text-align: center;\n  border: 2px solid;\n\n  cursor: pointer;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  display: flex;\n  flex-direction: row;\n\n  transition: background-color 0.2s ease-in-out, transform 0.2s ease-in-out;\n}\n\n.App-button:active {\n  transform: scale(0.9);\n}\n\n.App-button-record {\n  border-color: var(--negative-color);\n  color: var(--negative-color);\n}\n\n.App-button-record-hover-allowed:hover {\n  background-color: var(--negative-color);\n  color: var(--modal-bg-color);\n}\n\n.App-button-connect {\n  border-color: var(--disabled-color);\n  color: var(--disabled-color);\n}\n\n.App-button-connect:hover {\n  background-color: var(--disabled-color);\n  color: var(--modal-bg-color);\n}\n\n.App-button-default {\n  border-color: var(--disabled-color);\n  color: var(--disabled-color);\n}\n\n.App-button-default:hover {\n  background-color: var(--disabled-color);\n  color: var(--modal-bg-color);\n}\n\n.App-button-default-active {\n  background-color: var(--disabled-color);\n  color: var(--modal-bg-color);\n}\n\n.App-button-mini {\n  padding-right: 25px;\n  padding-left: 25px;\n  margin-right: 0px;\n}\n\n.App-button-fill-space {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-right: 0;\n  margin-bottom: -15px;\n}\n\n.App-button-container-horizontal {\n  display: flex;\n  flex-direction: row;\n}\n\n.App-button-container-vertical {\n  display: flex;\n  flex-direction: column;\n}\n\n.App-data-type-text {\n  padding: 20px;\n  font-size: 14px;\n\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  animation-name: fadeIn;\n  animation-duration: 0.5s;\n  animation-delay: var(--animation-init-time);\n  animation-fill-mode: forwards; \n  opacity: 0%; /* Animates to 100% */\n}\n\n.App-position-lower-right {\n  right: 0px;\n  bottom: 0px;\n  position: fixed;\n}\n\n.App-position-lower-left {\n  left: 0px;\n  bottom: 0px;\n  position: fixed;\n}\n\n.App-position-lower-center {\n  bottom: 0px;\n  position: fixed;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.App-position-top-right {\n  right: 0px;\n  top: 0px;\n  position: fixed;\n}\n\n.App-recording-circle {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  background-color: var(--negative-color);\n\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n\n  animation-name: recordingPulse;\n  animation-duration: 1s;\n  animation-iteration-count: infinite;\n}\n\n.App-connecting-circle {\n  width: 48px;\n  height: 48px;\n  display: inline-block;\n\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.App-connecting-circle::after,\n.App-connecting-circle::before {\n  content: '';  \n  box-sizing: border-box;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 2px solid var(--positive-color);\n  position: absolute;\n  left: 0;\n  top: 0;\n  animation: connectingPulse 2s linear infinite;\n}\n.App-connecting-circle::after {\n  animation-delay: 1s;\n}\n\n.App-fade-in-animation {\n  animation-name: fadeIn;\n  animation-duration: 0.5s;\n  animation-delay: var(--animation-init-time);\n  animation-fill-mode: forwards; \n  opacity: 0%; /* Animates to 100% */\n}\n\n\n\n\n\n.Modal-background {\n  background-color: var(--modal-bg-color);\n  width: 50vw;\n  height: 35vh;\n  padding: 30px;\n  position: absolute;\n  border-radius: 50px;\n  backdrop-filter: blur(7.5px);\n  overflow: hidden;\n  \n  -webkit-box-shadow: 0px 0px 32px 6px rgba(0,0,0,0.5); \n  box-shadow: 0px 0px 32px 6px rgba(0,0,0,0.5);\n  \n  transition: background-color 0.2s ease-in-out;\n  animation-name: dropIn;\n  animation-duration: 0.5s;\n  animation-delay: var(--animation-init-time);\n  animation-fill-mode: forwards; \n\n  opacity: 0%; /* Animates to 100% */\n}\n\n.Modal-background:hover {\n  background-color: var(--modal-bg-hover-color);\n}\n\n.Modal-hidden {\n  opacity: 100%; /* Animates to 0% */\n\n  transition: background-color 0.2s ease-in-out;\n  animation-name: dropOut;\n  animation-duration: 0.5s;\n  animation-delay: 0s;\n  animation-fill-mode: forwards; \n}\n\n.Modal-title {\n  font-weight: 900;\n  font-size: 5vh;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.Modal-body {\n  font-weight: 400;\n  font-size: 3vh;\n  text-align: center;\n  margin-left: 50px;\n  margin-right: 50px;\n\n  position: absolute;\n  top: 45%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.Modal-button-container {\n  display: flex;\n  flex-direction: row-reverse;\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  width: 100%;\n}\n\n.Modal-button {\n  width: 100px;\n  height: 7vh;\n  line-height: 7vh;\n  font-weight: 900;\n\n  flex-grow: 1;\n  margin: 30px;\n  border-radius: 40px;\n  text-align: center;\n  border: 2px solid;\n\n  cursor: pointer;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n\n  transition: background-color 0.2s ease-in-out, transform 0.2s ease-in-out;\n}\n\n.Modal-button:active {\n  transform: scale(0.9);\n}\n\n.Modal-button-primary {\n  border-color: var(--positive-color);\n  color: var(--positive-color);\n  margin-left: 15px;\n}\n\n/* .Modal-button-primary:hover {\n  background-color: var(--positive-color);\n  color: var(--modal-bg-color);\n} */\n\n.Modal-button-primary-hover-allowed:hover {\n  background-color: var(--positive-color);\n  color: var(--modal-bg-color);\n}\n\n.Modal-button-secondary {\n  border-color: var(--disabled-color);\n  color: var(--disabled-color);\n  margin-right: 15px;\n}\n\n.Modal-button-secondary:hover {\n  background-color: var(--disabled-color);\n  color: var(--modal-bg-color);\n}\n\n.Modal-button-generic {\n  border-color: var(--text-color);\n  color: var(--text-color);\n  /* margin-right: 15px; */\n}\n\n.Modal-button-generic:hover {\n  background-color: var(--text-color);\n  color: var(--modal-bg-color);\n}\n\n\n\n\n\n@keyframes dropIn {\n  0%   {\n    margin-top: -100px;\n    opacity: 0%;\n  }\n  100% {\n    margin-top: 0px;\n    opacity: 100%;\n  }\n}\n\n@keyframes dropOut {\n  0%   {\n    margin-top: 0px;\n    opacity: 100%;\n  }\n  100% {\n    margin-top: 100px;\n    opacity: 0%;\n  }\n}\n\n@keyframes fadeIn {\n  0%   {\n    opacity: 0%;\n  }\n  100% {\n    opacity: 100%;\n  }\n}\n\n@keyframes fillCircle {\n  to { stroke-dasharray: 0 100; }\n}\n\n@keyframes recordingPulse {\n  0%   {\n    opacity: 100%;\n  }\n  50% {\n    opacity: 50%;\n  }\n  100% {\n    opacity: 100%;\n  }\n}\n\n@keyframes connectingPulse {\n  0% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n/* Plans - generate random waves on site startup and start with full wave, clear and let wave fill in if and when there's a connection */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
